import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { OrganizationService } from "../services/OrganizationService";
import { generateKey } from "../../lib/utils";

// `enabled` is required (not optional/defaulted) so a caller can't forget to
// gate this on auth state — this hook previously fired as soon as
// `facilityId > 0`, even before a valid access token existed, which was one
// of the causes of the spurious refresh calls fixed alongside this change.
const useAvailableFacilityComponents = (facilityId: number, enabled: boolean) => {
  const response = useQuery({
    queryKey: generateKey("availableFacilityComponents", facilityId),
    queryFn: () =>
      OrganizationService.fetchAvailableFacilityComponents(facilityId),
    staleTime: 15 * 60 * 1000, // 15 minutes. The time in milliseconds after data is considered stale.
    enabled: facilityId > 0 && enabled,
  });

  return useMemo(() => response, [response]);
};

export default useAvailableFacilityComponents;
